import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import PropTypes from 'prop-types';
import roles from 'role'

export default function CountryList({ match }) {
    
    const fields = [
        { name: 'Id', key: 'id' },
        { name: 'Name', key: 'name' },
        { name: 'Abbreviation', key: 'abbreviation' },
    ];

    return (
        <ListCRUD
            plural='countries'
            singular='country'
            fields={fields}
            match={match}
            disableViewButton
            canNew={[roles.ADMIN]}
        />
    );
}

CountryList.propTypes = {
    match: PropTypes.shape({
        url: PropTypes.string.isRequired,
    }).isRequired,
};